"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("../../../index"));
var Create_1 = __importDefault(require("../../../../Form/Forms/Inquiry/Create"));
var CreateInquiryModal = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? false : _b, _c = _a.volumeSetting, volumeSetting = _c === void 0 ? "L" : _c, _d = _a.weightSetting, weightSetting = _d === void 0 ? "KG" : _d, projectSelect = _a.projectSelect, containerSelect = _a.containerSelect, initialValues = _a.initialValues, mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, onSuccess = _a.onSuccess, restProps = __rest(_a, ["visible", "volumeSetting", "weightSetting", "projectSelect", "containerSelect", "initialValues", "mutation", "mutationVariablesFormatter", "onSuccess"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_1.default, __assign({}, restProps, { visible: visible, title: "Create Inquiry", footer: "", width: 720 }),
            react_1.default.createElement(Create_1.default, { mutation: mutation, mutationVariablesFormatter: mutationVariablesFormatter, onSuccess: onSuccess, volumeSetting: volumeSetting, weightSetting: weightSetting, initialValues: initialValues, projectSelect: projectSelect, containerSelect: containerSelect }))));
};
exports.default = CreateInquiryModal;
